var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4C2.89543 4 2 4.89543 2 6V16C2 16.9321 2.63766 17.7153 3.50056 17.9371C3.53409 16.0331 5.088 14.5 7 14.5C8.933 14.5 10.5 16.067 10.5 18H13.5C13.5 16.067 15.067 14.5 17 14.5C18.912 14.5 20.4659 16.0331 20.4994 17.9371C21.3623 17.7153 22 16.9321 22 16V12.75H15V11.25H21.4L18.6005 7.75061C18.2209 7.27618 17.6463 7 17.0387 7H15V6C15 4.89543 14.1046 4 13 4H4ZM8.81925 5.76876L9.70705 7.88245C9.75763 8.00287 9.86623 8.08546 9.99127 8.0986L12.1861 8.32926C12.4879 8.36098 12.6096 8.75313 12.3832 8.96447L10.7371 10.5015C10.6433 10.589 10.6019 10.7227 10.6286 10.8512L11.0972 13.1075C11.1617 13.4177 10.843 13.6601 10.581 13.5L8.67587 12.3362C8.6216 12.3031 8.56091 12.2865 8.50021 12.2865C8.43952 12.2865 8.37883 12.3031 8.32456 12.3362L6.4194 13.5C6.15744 13.6601 5.83876 13.4177 5.9032 13.1075L6.37186 10.8512C6.39856 10.7227 6.35708 10.589 6.2633 10.5015L4.61719 8.96447C4.39085 8.75313 4.51257 8.36098 4.81436 8.32926L7.00916 8.0986C7.1342 8.08546 7.2428 8.00287 7.29338 7.88245L8.18118 5.76876C8.30325 5.47812 8.69717 5.47812 8.81925 5.76876Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18C19 19.1046 18.1046 20 17 20C15.8954 20 15 19.1046 15 18C15 16.8954 15.8954 16 17 16C18.1046 16 19 16.8954 19 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckStar);
export default __webpack_public_path__ + "static/media/truck-star.43defa927b2cb0b430305d96203e7396.svg";
export { ForwardRef as ReactComponent };